import type { ReactNode } from "react";

/** Monospace reference code — scannable down a column, never wraps. */
export const RefCode = ({ children }: { children: ReactNode }) => (
  <span className="whitespace-nowrap font-mono text-[0.8125rem] text-content-secondary">
    {children}
  </span>
);
